import { defineMessages } from '@formatjs/intl';

export default defineMessages({
	effectiveDate: {
		id: 'legal.document.effectiveDate',
		defaultMessage: 'effective {date}',
		description: 'Text indicating when the document is effective.',
	},
	lastUpdated: {
		id: 'legal.document.lastUpdated',
		defaultMessage: 'last updated {date}',
		description: 'Text indicating when the document was last updated.',
	},
});
